// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"09010d97","239":"15e11d99","453":"2f57f6c8","455":"84807782"}[chunkId] + ".chunk.js";
};